import { render } from "./EmailForm.vue?vue&type=template&id=4242ffd1&ts=true"
import script from "./EmailForm.vue?vue&type=script&lang=ts"
export * from "./EmailForm.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./EmailForm.vue?vue&type=style&index=0&id=4242ffd1&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__